"use strict";

import { h } from "vue";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons-vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Header",

  components: {
    UserOutlined,
  },

  data() {
    return {
      h,
      LogoutOutlined,
    };
  },

  computed: {
    ...mapGetters(["user"]),

    username() {
      return this.user ? this.user.email.split("@")[0] : "";
    },
  },

  methods: {
    ...mapActions("auth", ["logout"]),

    async handleLogout() {
      try {
        const params = {
          api: this.$api,
        };

        const res = await this.logout(params);
        if (!res.error) this.$router.replace({ name: "login" });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
